import { Outlet } from "react-router-dom";
import { Stack, styled } from "@mui/material";

export const RsoLayout = () => {
  return (
    <RsoLayoutWrapper>
      <Outlet />
    </RsoLayoutWrapper>
  );
};

const RsoLayoutWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
